module.exports = __webpack_public_path__ + "static/media/icon-discount@2x.c0f858bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-discount@2x.png
// module id = 719
// module chunks = 0